/**
 * 类型转换的对照数组
 */
const types = [
  {
    old: 'mtext',
    new: 'multitext',
  },
  {
    old: 'options',
    new: 'select',
  },
  {
    old: 'moptions',
    new: 'multiselect',
  },
  {
    old: 'pictureMultipleOptions',
    new: 'imageMultiselect',
  },
]

export function getConvertType (type) {
  for (let i = 0; i < types.length; i++) {
    if (types[i].old === type) {
      return types[i].new
    }
  }
  return type
}

export function getRecoveryType (type) {
  for (let i = 0; i < types.length; i++) {
    if (types[i].new === type) {
      return types[i].old
    }
  }
  return type
}

export default {getConvertType, getRecoveryType}



// WEBPACK FOOTER //
// ./src/views/question-editor/format/type.js